<template>
  <main class="bg-white">
    <v-toolbar flat class="main-header main-header__shadow mb-6 px-5 py-2">
      <v-toolbar-title class="main-header__title">
        <h1>
          <v-icon class="mx-3 mb-1" @click="back">mdi-arrow-left</v-icon>
          <span v-if="!isEdited">New Role</span>
          <span v-else>Edit Role</span>
        </h1>
      </v-toolbar-title>

      <!-- <v-spacer></v-spacer>
      <v-toolbar-items class="main-header__contents">
        <v-btn
          class="my-auto mx-1 radius-12 text-capitalize"
          color="success"
          to="/settings/roles/create"
        >
          <v-icon>mdi-plus</v-icon>
          <span class="mx-2">Add License</span>
        </v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <v-container>
      <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
        <p
          class="mb-0"
          v-for="globalErr in globalServerErrors"
          :key="globalErr"
        >
          {{ globalErr[0] }}
        </p>
      </v-alert>
      <formWrapper :validator="$v.form">
        <form @submit.prevent="handleSave" class="form-box">
          <v-row>
            <v-col cols="12" sm="8">
              <v-row>
                <!-- <v-col cols="12" v-if="isEdited">
                  <locale-select @change="fireLocaleChange" />
                </v-col> -->
                <v-col class="py-0" cols="12">
                  <form-group name="name" :attribute="`fields.name`">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="listeners"
                        outlined
                        v-model.trim="form.name"
                        type="text"
                      >
                      </v-text-field>
                    </template>
                  </form-group>
                </v-col>
                <v-col v-if="isEdited" cols="12">
                  <section v-for="(item, i) in permissions" :key="i">
                    <h3
                      v-if="item.permissions.length > 0"
                      class="color-gray mb-5"
                    >
                      {{ item ? item.name : "" }}
                    </h3>
                    <!-- <p>{{ item.name }}</p> -->
                    <template v-for="(permission, index) in item.permissions">
                      <div :key="index">
                        <!-- {{ permission }} -->
                        <v-row no-gutters>
                          <v-col sm="6" cols="12">
                            <section class="transparent-field pt-5">
                              <v-switch
                                v-model="permission.selected"
                                inset
                                class="mt-0"
                                :label="permission.name"
                                color="success"
                                @change="changeToggle(permission)"
                              ></v-switch>
                            </section>
                          </v-col>
                          <v-col sm="6" cols="12">
                            <v-autocomplete
                              :items="permission.sub_permissions"
                              item-text="name"
                              item-value="id"
                              regular
                              multiple
                              return-object
                              label="Choose"
                              :disabled="!permission.selected"
                              v-model="formIds[permission.id]"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                  </section>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    class="success text-capitalize"
                    large
                    type="submit"
                    width="30%"
                    :disabled="$v.form.$invalid"
                    ><span>Save</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </form>
      </formWrapper>
    </v-container>
  </main>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import cookie from "js-cookie";
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
export default {
  data() {
    return {
      globalServerErrors: null,
      isEdited: false,
      equality: "",
      permissions: [],
      locale: cookie.get("language") || "en",
      form: {
        name: ""
      },
      formIds: {},
      selectedPermissions: [],
      role_id: {}
    };
  },
  computed: {
    permissionKeys() {
      return [
        {
          name: "permissions",
          items: this.permissions,
          label: "Permissions",
          visible: 0
        }
      ];
    }
  },
  created() {
    this.editCreateBoolean();
  },
  methods: {
    editCreateBoolean() {
      if (this.$route.name == "rolesUpdate") {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    show(id, locale) {
      ShowData({
        reqName: `admin-panel/roles`,
        id: id,
        locale
      })
        .then(res => {
          const { role } = res.data;
          this.equality = role.name;
          this.form.name = role.name;
          this.permissions = role.permission_groups;

          let selectedPermissions = [];
          role.permission_groups.map(per => {
            per.permissions.forEach(element => {
              if (element.selected) {
                element.sub_permissions.forEach(sub => {
                  if (sub.selected) {
                    selectedPermissions.push({ [element.id]: sub });
                  }
                });
              }
            });
          });

          const finalObj = {};
          for (let objectValue of selectedPermissions) {
            for (let key in objectValue) {
              if (finalObj.hasOwnProperty(key)) {
                finalObj[key].push(objectValue[key]);
              } else {
                finalObj[key] = [objectValue[key]];
              }
            }
          }
          this.formIds = finalObj;
        })
        .catch(() => {});
    },
    update() {
      const formData = new FormData();
      Object.keys(this.formIds).forEach((formKey, index) => {
        formData.append(`permissions[${index}][id]`, formKey);
        this.formIds[formKey].forEach((subPermission, i) => {
          formData.append(
            `permissions[${index}][sub_permissions][${i}]`,
            subPermission.id
          );
        });
      });

      formData.append("_method", "put");
      formData.append("locale", this.locale);
      if (this.form.name !== this.equality) {
        formData.append("name", this.form.name);
      }
      UpdateData({
        reqName: `admin-panel/roles`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.back();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.create();
      } else {
        this.update();
      }
    },
    create() {
      StoreData({
        reqName: `admin-panel/roles`,
        data: this.form
      })
        .then(() => {
          this.back();
        })
        .catch(err => {
          console.log(err);
          // this.loading.save = false;
        });
    },
    back() {
      history.go(-1);
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    fireLocaleChange(locale) {
      this.show(this.form.id, locale);
      this.locale = locale;
    },
    changeToggle(permission) {
      if (!permission.selected) {
        delete this.formIds[permission.id];
      }
      // console.log(permission.sub_);
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "rolesUpdate") {
          this.$nextTick(() => {
            this.show(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(195)
      }
    }
  }
};
</script>
